import React from 'react'; 
import HeaderNav from '../components/HeaderNav';
import PageIntro from '../components/PageIntro';
import ServicePanels from '../components/ServicePanels';

function Services() {

    return (
      <div id="mainContent">
        <div id="navHolder">
          <HeaderNav pageTitle="services" />
        </div>
        <div id = "intro">
            <h1>SERVICES</h1>
            <PageIntro pageTitle="Services" output="intro"/>
        </div>
        <div id="servicesContent" className="pagePanels">
            <ServicePanels page="LANDING" mode="grid" />
        </div>
      </div>
    );
  }
export default Services;
